// Replace the placeholder with your Facebook App ID
const FACEBOOK_APP_ID = '1534596847784255';

export { FACEBOOK_APP_ID };